/**
 * HTTP paths under the API prefix (axios `baseURL` is `${origin}/api`).
 * Keep in sync with Nest controllers in `ph-auto-alter-news-portal/backend`.
 * OAuth redirect URI ends with `/api/auth/google/callback`.
 */
export const apiPaths = {
  health: () => "/health",

  categories: {
    list: () => "/categories",
    one: (id: string) => `/categories/${id}`,
  },

  articles: {
    list: () => "/articles",
    latest: () => "/articles/latest",
    one: (id: string) => `/articles/${id}`,
    comments: (articleId: string) => `/articles/${articleId}/comments`,
    comment: (articleId: string, commentId: string) =>
      `/articles/${articleId}/comments/${commentId}`,
    reactions: {
      summary: (articleId: string) =>
        `/articles/${articleId}/reactions/summary`,
      collection: (articleId: string) => `/articles/${articleId}/reactions`,
    },
  },

  users: {
    me: () => "/users/me",
  },

  auth: {
    /** `GET /api/auth/google` (segment after global prefix). */
    google: () => "/auth/google",
    logout: () => "/auth/logout",
  },
} as const;
